import { cn } from '@plato/ui/util/classes';

type Props = {
    className?: string;
};

export function BuildingIcon({ className = '' }: Props) {
    return (
        <svg
            className={cn('stroke-neutral-400', className)}
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="14"
            fill="none"
            viewBox="0 0 15 14"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M1 13h13M2 1v12M9 1v12m4-9v9M4 3.5h.5m-.5 2h.5m-.5 2h.5m2-4H7m-.5 2H7m-.5 2H7M4 13v-2.25a.75.75 0 01.75-.75h1.5a.75.75 0 01.75.75V13M1.5 1h8M9 4h4.5M11 6.5h.005v.005H11V6.5zm0 2h.005v.005H11V8.5zm0 2h.005v.005H11V10.5z"
            ></path>
        </svg>
    );
}
